import React from 'react'
import { DetailsViewWrapper, HeaderContent } from '../general'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { TibberSvg } from '../../resources'
import { FooterContent } from './helpers'
import { ExtensionTypes, ExtensionDetailsProps } from '../../types'
import { useTheme } from '@mui/material'
import { extensionColors } from '../../colors'
import { isFlowTheme } from 'src/Libs/utils/theme-helpers'

/**
 * Gives a detailed description of the tibber marketing extension.
 */
const TibberDetails: React.FC<ExtensionDetailsProps> = ({ extensionState, hasActiveTariff, onClose, place = 0, isLoading }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()

  const contractStateProps = {
    contractState: extensionState,
    isLoading,
  }
  const description = isFlowTheme
    ? t('installation-extensions.tibber.details.description.flow')
    : t('installation-extensions.tibber.details.description')
  const description2 = isFlowTheme
    ? t('installation-extensions.tibber.details.description2.flow')
    : t('installation-extensions.tibber.details.description2')

  return (
    <DetailsViewWrapper
      extensionType={ExtensionTypes.Tibber}
      descriptions={[description, description2]}
      headerContent={
        <HeaderContent
          logo={<TibberSvg fill={extensionColors[ExtensionTypes.Tibber].primary} textFill={extensionColors[ExtensionTypes.Tibber].primary} />}
        />
      }
      footerContent={<FooterContent extensionState={extensionState} hasActiveTariff={hasActiveTariff} />}
      onClose={onClose}
      place={place}
      open={true}
      category={{ name: 'dynamic-energy-tariff', paletteColor: theme.palette.secondary }}
      contractStateProps={contractStateProps}
    />
  )
}

export default TibberDetails
